import { PermissionID } from 'ctp-user-auth-service';
import { IRole, PermissionsState } from './types';

const getters = {
  getCurrentUserRole(state: PermissionsState): IRole | undefined {
    return state.currentUserRole;
  },
  getCurrentUserRolePermissions(state: PermissionsState): PermissionID[] {
    return state.currentUserRole && state.currentUserRole.permissions
      ? state.currentUserRole.permissions : [];
  },
  getCurrentUserIsAbleTo: (state: PermissionsState) => (
    readOrWrite: string,
    featureName: string
  ) => {
    const permissions = state.currentUserRole && state.currentUserRole.permissions
      ? state.currentUserRole.permissions : [];
    let isAbleToRead = false;
    permissions.forEach((permission: PermissionID) => {
      if (permission.toString().includes(featureName)
        && permission.toString().includes(readOrWrite)) {
        isAbleToRead = true;
      }
    });
    return isAbleToRead;
  }
};

export default getters;
